import {useQuery} from "react-query";

import {UserService} from "../../../services/UserService";

type Params = {userId: string; enabled?: boolean};

export const useUserQuery = ({userId, enabled = true}: Params) =>
  useQuery(
    ["useUserQuery", userId],
    async ({queryKey: [_, userId]}) => {
      const {data} = await UserService.find(userId);
      return data;
    },
    {
      enabled: enabled && Boolean(userId),
    },
  );
